import React from 'react';
import PropTypes from 'prop-types';
import ConnectedReportList from './ConnectedReportList';

function ReportListRouting({ match }) {
  return <ConnectedReportList />;
}

ReportListRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ReportListRouting;
